import './persik.d.ts';

export const PERSIK_ROUTE_ENABLED_STORAGE_ITEM = 'IS_PERSIK_ROUTE_ENABLED';

window.persik = {
  checkIsRouteEnabled: () => {
    return PERSIK_ROUTE_ENABLED_STORAGE_ITEM in localStorage;
  },
  enableRoute: () => {
    localStorage.setItem(PERSIK_ROUTE_ENABLED_STORAGE_ITEM, '1');
    window.location.reload();
  },
  disableRoute: () => {
    localStorage.removeItem(PERSIK_ROUTE_ENABLED_STORAGE_ITEM);
    window.location.reload();
  },
};

export const IS_PERSIK_ROUTE_ENABLED = window.persik.checkIsRouteEnabled();
